import { InputWithSuffix } from '@components/ui/input-group'
import { Slider } from '@components/ui/slider'
import { cn } from '@/utils'
import type { DropCapNumberField as DropCapNumberFieldState } from '../hooks/use-drop-cap-number-field'
import { FieldError } from './field-error'

interface DropCapNumberFieldProps {
  label: string
  field: DropCapNumberFieldState
  min: number
  max: number
  suffix: string
  errorId: string
  disabled: boolean
}

/** One Drop Cap numeric row (Lines or Offset): label, slider, input and error. */
export function DropCapNumberField({
  label,
  field,
  min,
  max,
  suffix,
  errorId,
  disabled,
}: DropCapNumberFieldProps) {
  const hasError = field.errorKind != null

  return (
    <div className="space-y-3">
      <label className="text-sm font-medium text-foreground leading-normal">{label}</label>
      <div className="flex items-center gap-[1.125rem] mt-2">
        <Slider
          value={field.displayedValue}
          onValueChange={field.handleSliderChange}
          onValueCommit={field.restoreActiveEditor}
          disabled={disabled}
          min={min}
          max={max}
          step={1}
          className="flex-1 min-w-0 max-w-[8.125rem]"
        />
        <div className="flex flex-col">
          <InputWithSuffix
            type="text"
            value={field.displayedInputValue}
            disabled={disabled}
            placeholder={field.mixed ? 'Mixed' : undefined}
            error={hasError}
            aria-describedby={hasError ? errorId : undefined}
            onFocus={field.handleFocus}
            onChange={field.handleChange}
            onKeyDown={field.handleKeyDown}
            onBlur={field.handleBlur}
            size="compact"
            suffix={<span className={cn(field.mixed && 'text-muted-foreground/70')}>{suffix}</span>}
          />
          {hasError && <FieldError id={errorId}>{field.errorMessage}</FieldError>}
        </div>
      </div>
    </div>
  )
}
